module.exports = __webpack_public_path__ + "img/jzlbg6.4813e903.png";